module.exports = __webpack_public_path__ + "static/media/ms-marvel-vol6-civil-war-ii.362ab61e.jpg";